/**
 * Superbundle variant selector — PDP + Quick Buy.
 *
 * Liquid still renders `.superbundle-selector` with data-* config.
 * This file binds the Regular/Bundle switch, fly-bundle ATC, and qty UI.
 * Quick Buy calls `window.PWSuperbundle.initIn(modal)` after morph because
 * inline scripts inside fetched PDP HTML do not execute.
 */
(function () {
  function isQuickBuyContext(el) {
    return !!(el && el.closest && el.closest('#quick-add-modal-content, quick-add-dialog, .quick-add-modal'));
  }

  function getRoot(selector) {
    return (
      selector.closest('#quick-add-modal-content, quick-add-dialog, [data-product-grid-content], .product-information') ||
      document
    );
  }

  function findSelectorFor(fromEl) {
    if (fromEl && fromEl.closest) {
      var own = fromEl.closest('.superbundle-selector');
      if (own) return own;
      var scopedRoot = fromEl.closest('#quick-add-modal-content, quick-add-dialog, [data-product-grid-content], .shopify-section');
      if (scopedRoot) {
        var scoped = scopedRoot.querySelector('.superbundle-selector');
        if (scoped) return scoped;
      }
    }
    var modal = document.getElementById('quick-add-modal-content');
    var dialogOpen = document.querySelector('quick-add-dialog dialog[open]');
    if (dialogOpen && modal) {
      var inModal = modal.querySelector('.superbundle-selector');
      if (inModal) return inModal;
    }
    return document.querySelector('.superbundle-selector');
  }

  window.__superbundleSwitchTo = function (mode, fromEl) {
    var selector = findSelectorFor(fromEl);
    if (selector && typeof selector.__sbSwitchTo === 'function') {
      selector.__sbSwitchTo(mode);
    }
  };

  function initSelector(selector) {
    if (!selector || selector.dataset.sbInited === 'true') return;

    var root = getRoot(selector);
    var isQuickBuy = isQuickBuyContext(selector);
    var isFlyParent = selector.classList.contains('superbundle-fly-parent');

    /* Fly-parent markup exists on PDP too; only bind ATC inside Quick Buy. */
    if (isFlyParent && !isQuickBuy) return;

    selector.dataset.sbInited = 'true';

    /* Isolate modal radios from a PDP instance of the same name. */
    if (isQuickBuy && !isFlyParent) {
      selector.querySelectorAll('input[name="superbundle-option"]').forEach(function (radio) {
        radio.name = 'superbundle-option-qv';
      });
    }

    /* When combined with linked_products, place Superbundle after linked pills on one row */
    if (!isFlyParent && selector.classList.contains('superbundle-selector--with-linked')) {
      var alreadyWrapped = selector.parentElement && selector.parentElement.classList.contains('linked-with-superbundle');
      if (!alreadyWrapped) {
        var linkedRow = root.querySelector('[data-linked-main-variants]');
        if (linkedRow && linkedRow.parentNode) {
          var wrap = document.createElement('div');
          wrap.className = 'linked-with-superbundle';
          linkedRow.parentNode.insertBefore(wrap, linkedRow);
          wrap.appendChild(linkedRow);
          wrap.appendChild(selector);
        }
      }
    }

    var buyBlock = root.querySelector('.buy-buttons-main-container .buy-buttons-block') || root.querySelector('.buy-buttons-block');
    var buyContainer = root.querySelector('.buy-buttons-main-container');
    var stickyBar = isQuickBuy ? null : document.querySelector('product-sticky-bar');
    var bundleWrap = null;
    var atcSection = null;
    var qtySection = null;
    var bundleAtcBtn = null;
    var qtyInput = null;
    var deleteIcon = null;
    var minusIcon = null;

    var stickyDesktopForm = stickyBar ? stickyBar.querySelector('.product-sticky-bar__desktop product-form-component') : null;
    var stickyMobileForm = stickyBar ? stickyBar.querySelector('.product-sticky-bar__mobile product-form-component') : null;
    var stickyBundleUI = { desktop: null, mobile: null };

    var prices = {
      regular: { price: parseInt(selector.dataset.regularPrice, 10), compare: parseInt(selector.dataset.regularComparePrice, 10) },
      bundle: { price: parseInt(selector.dataset.bundlePrice, 10), compare: parseInt(selector.dataset.bundleComparePrice, 10) }
    };

    var bundleFlyIds = selector.dataset.bundleFlyIds;
    var bundleOfferId = selector.dataset.bundleOfferId;
    var bundleName = selector.dataset.bundleName || '';
    var bundleDigitalMapRaw = selector.dataset.bundleDigitalMap || null;
    var bundleHandle = selector.dataset.bundleHandle;
    var bundleLineProps = {};
    try {
      bundleLineProps = JSON.parse(selector.dataset.bundleLineProps || '{}');
    } catch (e) {
      bundleLineProps = {};
    }

    function findBundleParentItem(cart, offerIdKeyed) {
      var items = (cart && cart.items) || [];
      return (
        items.find(function (item) {
          var props = item.properties || {};
          return props.OfferId === offerIdKeyed || props['_flyBundles:OfferId'] === offerIdKeyed;
        }) || null
      );
    }

    function applySuperbundleLineProps(offerIdKeyed, attempt) {
      if (!bundleLineProps || !Object.keys(bundleLineProps).length) {
        return Promise.resolve();
      }
      var tryCount = attempt || 0;
      return fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var parent = findBundleParentItem(cart, offerIdKeyed);
          if (!parent || !parent.key) {
            if (tryCount < 2) {
              return new Promise(function (resolve) {
                setTimeout(function () {
                  resolve(applySuperbundleLineProps(offerIdKeyed, tryCount + 1));
                }, 300);
              });
            }
            return null;
          }
          var merged = Object.assign({}, parent.properties || {}, bundleLineProps);
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: parent.key,
              quantity: parent.quantity,
              properties: merged
            })
          });
        })
        .catch(function (err) {
          console.error('Superbundle line props error:', err);
        });
    }

    var titleEl = root.querySelector('.product-title-share-title') || root.querySelector('.view-product-title a, .product-header a');
    var regularTitle = selector.dataset.regularTitle;
    var bundleTitle = selector.dataset.bundleTitle;

    var originalGalleryNode = null;
    var bundleGalleryNode = null;
    var isBundleGallery = false;
    var galleryFetching = false;
    var pendingBundleSwap = false;

    var bundleQty = 0;
    var bundleItemKeys = [];
    var isCartBusy = false;

    function formatPrice(paise) {
      var rupees = Math.floor(paise / 100);
      return '\u20B9 ' + rupees.toLocaleString('en-IN');
    }

    function syncBundleStateFromCart() {
      if (!bundleOfferId) return;
      fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var groups = {};
          var order = [];
          for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            var props = item.properties || {};
            var offerProp = props['_flyBundles:OfferId'] || props['OfferId'];
            if (!offerProp || offerProp.indexOf(bundleOfferId + '_') !== 0) continue;
            if (!groups[offerProp]) {
              groups[offerProp] = [];
              order.push(offerProp);
            }
            groups[offerProp].push(item.key);
          }
          bundleQty = order.length;
          bundleItemKeys = order.map(function (id) {
            return groups[id];
          });
          refreshQtyUI();
        })
        .catch(function () {});
    }

    if (bundleHandle) {
      galleryFetching = true;
      fetch('/products/' + bundleHandle)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var bg = doc.querySelector('media-gallery');
          if (bg) bundleGalleryNode = document.adoptNode(bg);
          galleryFetching = false;
          if (pendingBundleSwap) {
            pendingBundleSwap = false;
            doGallerySwap();
          }
        })
        .catch(function () {
          galleryFetching = false;
        });
    }

    function doGallerySwap() {
      var gallery = root.querySelector('media-gallery');
      if (!gallery || !bundleGalleryNode) return;
      originalGalleryNode = gallery;
      gallery.replaceWith(bundleGalleryNode);
      isBundleGallery = true;
    }

    function createBundleUI() {
      var w = document.createElement('div');
      w.className = 'superbundle-atc-wrapper';
      w.style.display = 'none';
      w.innerHTML =
        '<div class="superbundle-atc-section">' +
          '<div class="product-form-buttons">' +
            '<span class="add-to-cart-button-wrapper">' +
              '<button type="button" class="button button--primary superbundle-atc-btn">' +
                '<span aria-hidden="true" class="add-to-cart-text--added"><span>' +
                  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15.7505 10.5V6C15.7505 3.92893 14.0716 2.25 12.0005 2.25C9.92942 2.25 8.25048 3.92893 8.25048 6V10.5M19.6065 8.50723L20.8697 20.5072C20.9396 21.1715 20.4188 21.75 19.7508 21.75H4.25012C3.58221 21.75 3.06138 21.1715 3.1313 20.5072L4.39446 8.50723C4.45473 7.93466 4.93755 7.5 5.51328 7.5H18.4877C19.0634 7.5 19.5462 7.93466 19.6065 8.50723ZM8.62548 10.5C8.62548 10.7071 8.45759 10.875 8.25048 10.875C8.04338 10.875 7.87548 10.7071 7.87548 10.5C7.87548 10.2929 8.04338 10.125 8.25048 10.125C8.45759 10.125 8.62548 10.2929 8.62548 10.5ZM16.1255 10.5C16.1255 10.7071 15.9576 10.875 15.7505 10.875C15.5434 10.875 15.3755 10.7071 15.3755 10.5C15.3755 10.2929 15.5434 10.125 15.7505 10.125C15.9576 10.125 16.1255 10.2929 16.1255 10.5Z" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
                '</span></span>' +
                '<span class="add-to-cart-text"><span class="add-to-cart-text__content">Add to Bag</span></span>' +
              '</button>' +
            '</span>' +
          '</div>' +
        '</div>' +
        '<div class="superbundle-qty-section" style="display:none;">' +
          '<div class="product-form-buttons">' +
            '<div class="product-quantity-selector">' +
              '<button type="button" class="button quantity-delete-minus button-unstyled sb-minus-btn">' +
                '<span class="svg-wrapper quantity-icon quantity-icon--delete">' +
                  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.7404 9L14.3942 18M9.60577 18L9.25962 9M19.2276 5.79057C19.5696 5.84221 19.9104 5.89747 20.25 5.95629M19.2276 5.79057L18.1598 19.6726C18.0696 20.8448 17.0921 21.75 15.9164 21.75H8.08357C6.90786 21.75 5.93037 20.8448 5.8402 19.6726L4.77235 5.79057M19.2276 5.79057C18.0812 5.61744 16.9215 5.48485 15.75 5.39432M3.75 5.95629C4.08957 5.89747 4.43037 5.84221 4.77235 5.79057M4.77235 5.79057C5.91878 5.61744 7.07849 5.48485 8.25 5.39432M15.75 5.39432V4.47819C15.75 3.29882 14.8393 2.31423 13.6606 2.27652C13.1092 2.25889 12.5556 2.25 12 2.25C11.4444 2.25 10.8908 2.25889 10.3394 2.27652C9.16065 2.31423 8.25 3.29882 8.25 4.47819V5.39432M15.75 5.39432C14.5126 5.2987 13.262 5.25 12 5.25C10.738 5.25 9.48744 5.2987 8.25 5.39432" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                '</span>' +
                '<span class="svg-wrapper quantity-icon quantity-icon--minus" hidden>' +
                  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                '</span>' +
              '</button>' +
              '<input type="number" value="1" disabled class="sb-qty-input">' +
              '<button type="button" class="button quantity-plus button-unstyled sb-plus-btn">' +
                '<span class="svg-wrapper icon-plus">' +
                  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4.5V19.5M19.5 12L4.5 12" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                '</span>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';

      if (buyContainer) {
        buyContainer.appendChild(w);
      } else if (buyBlock && buyBlock.parentNode) {
        buyBlock.parentNode.appendChild(w);
      } else {
        var form = root.querySelector('product-form-component');
        if (form && form.parentNode) form.parentNode.appendChild(w);
        else root.appendChild(w);
      }

      atcSection = w.querySelector('.superbundle-atc-section');
      qtySection = w.querySelector('.superbundle-qty-section');
      bundleAtcBtn = w.querySelector('.superbundle-atc-btn');
      qtyInput = w.querySelector('.sb-qty-input');
      deleteIcon = w.querySelector('.quantity-icon--delete');
      minusIcon = w.querySelector('.quantity-icon--minus');

      bundleAtcBtn.addEventListener('click', function () {
        addBundleToCart();
      });
      w.querySelector('.sb-plus-btn').addEventListener('click', function () {
        addBundleToCart();
      });
      w.querySelector('.sb-minus-btn').addEventListener('click', handleMinus);

      return w;
    }

    function createStickyBundleUI() {
      if (!stickyBar) return;
      var svgDel =
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.7404 9L14.3942 18M9.60577 18L9.25962 9M19.2276 5.79057C19.5696 5.84221 19.9104 5.89747 20.25 5.95629M19.2276 5.79057L18.1598 19.6726C18.0696 20.8448 17.0921 21.75 15.9164 21.75H8.08357C6.90786 21.75 5.93037 20.8448 5.8402 19.6726L4.77235 5.79057M19.2276 5.79057C18.0812 5.61744 16.9215 5.48485 15.75 5.39432M3.75 5.95629C4.08957 5.89747 4.43037 5.84221 4.77235 5.79057M4.77235 5.79057C5.91878 5.61744 7.07849 5.48485 8.25 5.39432M15.75 5.39432V4.47819C15.75 3.29882 14.8393 2.31423 13.6606 2.27652C13.1092 2.25889 12.5556 2.25 12 2.25C11.4444 2.25 10.8908 2.25889 10.3394 2.27652C9.16065 2.31423 8.25 3.29882 8.25 4.47819V5.39432M15.75 5.39432C14.5126 5.2987 13.262 5.25 12 5.25C10.738 5.25 9.48744 5.2987 8.25 5.39432" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var svgMin =
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var svgPlus =
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4.5V19.5M19.5 12L4.5 12" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      function makeUI(type) {
        var isD = type === 'desktop';
        var atcCls = isD ? 'product-sticky-bar__atc-button' : 'product-sticky-bar__mobile-atc-button';
        var w = document.createElement('div');
        w.className = 'sb-sticky-bundle-wrap';
        w.style.cssText = 'display:none;width:100%;';
        w.innerHTML =
          '<div style="display:flex;align-items:center;gap:12px;width:100%;">' +
            '<span class="sb-sticky-atc-section" style="flex:1;">' +
              '<button type="button" class="button-secondary ' +
              atcCls +
              ' sb-sticky-bundle-atc" style="width:100%;"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15.7505 10.5V6C15.7505 3.92893 14.0716 2.25 12.0005 2.25C9.92942 2.25 8.25048 3.92893 8.25048 6V10.5M19.6065 8.50723L20.8697 20.5072C20.9396 21.1715 20.4188 21.75 19.7508 21.75H4.25012C3.58221 21.75 3.06138 21.1715 3.1313 20.5072L4.39446 8.50723C4.45473 7.93466 4.93755 7.5 5.51328 7.5H18.4877C19.0634 7.5 19.5462 7.93466 19.6065 8.50723ZM8.62548 10.5C8.62548 10.7071 8.45759 10.875 8.25048 10.875C8.04338 10.875 7.87548 10.7071 7.87548 10.5C7.87548 10.2929 8.04338 10.125 8.25048 10.125C8.45759 10.125 8.62548 10.2929 8.62548 10.5ZM16.1255 10.5C16.1255 10.7071 15.9576 10.875 15.7505 10.875C15.5434 10.875 15.3755 10.7071 15.3755 10.5C15.3755 10.2929 15.5434 10.125 15.7505 10.125C15.9576 10.125 16.1255 10.2929 16.1255 10.5Z" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>Add to Bag</button>' +
            '</span>' +
            '<span class="sb-sticky-qty-section" style="display:none;flex:1;">' +
              '<div class="product-quantity-selector" style="width:100%;">' +
                '<button type="button" class="button quantity-delete-minus button-unstyled sb-sticky-minus-btn">' +
                  '<span class="svg-wrapper quantity-icon quantity-icon--delete">' +
                  svgDel +
                  '</span>' +
                  '<span class="svg-wrapper quantity-icon quantity-icon--minus" hidden>' +
                  svgMin +
                  '</span>' +
                '</button>' +
                '<input type="number" value="1" disabled class="sb-sticky-qty-input">' +
                '<button type="button" class="button quantity-plus button-unstyled sb-sticky-plus-btn">' +
                  '<span class="svg-wrapper icon-plus">' +
                  svgPlus +
                  '</span>' +
                '</button>' +
              '</div>' +
            '</span>' +
          '</div>';
        w.querySelector('.sb-sticky-bundle-atc').addEventListener('click', function () {
          addBundleToCart();
        });
        w.querySelector('.sb-sticky-plus-btn').addEventListener('click', function () {
          addBundleToCart();
        });
        w.querySelector('.sb-sticky-minus-btn').addEventListener('click', handleMinus);
        return {
          wrap: w,
          atcSection: w.querySelector('.sb-sticky-atc-section'),
          qtySection: w.querySelector('.sb-sticky-qty-section'),
          atcBtn: w.querySelector('.sb-sticky-bundle-atc'),
          qtyInput: w.querySelector('.sb-sticky-qty-input'),
          deleteIcon: w.querySelector('.quantity-icon--delete'),
          minusIcon: w.querySelector('.quantity-icon--minus')
        };
      }

      var dActions = stickyBar.querySelector('.product-sticky-bar__actions');
      if (dActions) {
        stickyBundleUI.desktop = makeUI('desktop');
        dActions.appendChild(stickyBundleUI.desktop.wrap);
      }
      var mActions = stickyBar.querySelector('.product-sticky-bar__mobile-actions');
      if (mActions) {
        stickyBundleUI.mobile = makeUI('mobile');
        mActions.appendChild(stickyBundleUI.mobile.wrap);
      }
    }

    function fireSuperbundleAddToBagTracking() {
      if (typeof window.addToCartGtm !== 'function') return;
      var productDataFromBundle = null;
      try {
        var rawGtm = selector.dataset.bundleGtm;
        if (rawGtm) productDataFromBundle = JSON.parse(rawGtm);
      } catch (_) {}
      var variantId = selector.dataset.bundleVariantId || null;
      var payload = Object.assign(
        {},
        productDataFromBundle && typeof productDataFromBundle === 'object' ? productDataFromBundle : {},
        {
          product_id: selector.dataset.bundleProductId || null,
          product_variant_id: variantId != null ? String(variantId) : null,
          product_title: selector.dataset.bundleTitle || bundleName || null,
          product_slug: bundleHandle || null,
          total_quantity: 1,
          cta_name: 'add_to_bag',
          triggerElement: bundleAtcBtn || selector
        }
      );
      setTimeout(function () {
        window.addToCartGtm(payload);
      }, 0);
    }

    function bundleCanAdd() {
      if (selector.dataset.bundlePreorder === 'yes') return true;
      return selector.dataset.bundleAvailable !== 'false';
    }

    function syncQuickBuyBundleButton() {
      if (!isQuickBuy || !bundleAtcBtn) return;
      var canAdd = bundleCanAdd();
      var label = bundleAtcBtn.querySelector('.add-to-cart-text__content');
      if (label) label.textContent = canAdd ? 'Add to Bag' : 'Out of Stock';
      bundleAtcBtn.disabled = !canAdd;
      bundleAtcBtn.setAttribute('aria-disabled', canAdd ? 'false' : 'true');
    }

    function addBundleToCart() {
      if (isCartBusy) return;
      if (isQuickBuy && !bundleCanAdd()) return;

      var childData;
      try {
        childData = JSON.parse(bundleFlyIds);
      } catch (x) {
        return;
      }

      var digitalMap = null;
      try {
        digitalMap = JSON.parse(bundleDigitalMapRaw || 'null');
      } catch (x) {}

      var rk = Math.random().toString(36).substring(2, 5);
      var offerIdKeyed = bundleOfferId + '_' + rk;

      var items = [];
      var keys = Object.keys(childData);
      for (var k = 0; k < keys.length; k++) {
        var vid = parseInt(childData[keys[k]][0], 10);
        if (!vid) continue;
        var isDigital = digitalMap && digitalMap.hasOwnProperty(String(vid)) ? digitalMap[String(vid)] === true : false;
        items.push({
          id: vid,
          quantity: 1,
          properties: {
            '_flyBundles:OfferId': offerIdKeyed,
            '_flyBundles:prodQty': 1,
            '_flyBundles:customField': bundleName,
            _digital_book: isDigital ? 'true' : 'false',
            _purchase_type: 'null'
          }
        });
      }
      if (!items.length) return;

      isCartBusy = true;
      if (bundleAtcBtn) {
        bundleAtcBtn.classList.add('loading');
        bundleAtcBtn.disabled = true;
      }
      ['desktop', 'mobile'].forEach(function (k) {
        var u = stickyBundleUI[k];
        if (u && u.atcBtn) u.atcBtn.disabled = true;
      });

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'product-form-component', itemCount: 1, isOptimistic: true } }
        })
      );

      fetch('/cart/add.js?app=gfbBundleApp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          bundleQty++;
          isCartBusy = false;
          refreshQtyUI();
          fireSuperbundleAddToBagTracking();
          // Quick Buy: product-form closes via cart:update bubbling from inside the dialog.
          // Superbundle ATC dispatches on document, so close the modal explicitly on success.
          if (isQuickBuy) {
            var dialogComponent = document.getElementById('quick-add-dialog');
            if (dialogComponent && typeof dialogComponent.closeDialog === 'function') {
              dialogComponent.closeDialog();
            }
          }
          return r.text();
        })
        .then(function (text) {
          try {
            var data = JSON.parse(text);
            var addedKeys = [];
            if (data.items) {
              for (var i = 0; i < data.items.length; i++) {
                if (data.items[i].key) addedKeys.push(data.items[i].key);
              }
            }
            bundleItemKeys.push(addedKeys);
          } catch (e) {
            bundleItemKeys.push([]);
          }
          return applySuperbundleLineProps(offerIdKeyed);
        })
        .catch(function (err) {
          console.error('Superbundle ATC error:', err);
          isCartBusy = false;
          if (bundleAtcBtn) {
            bundleAtcBtn.classList.remove('loading');
            if (isQuickBuy) syncQuickBuyBundleButton();
            else bundleAtcBtn.disabled = false;
          }
          ['desktop', 'mobile'].forEach(function (k) {
            var u = stickyBundleUI[k];
            if (u && u.atcBtn) u.atcBtn.disabled = false;
          });
          fetch('/cart.js')
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: { data: { source: 'superbundle-atc', itemCount: cart.item_count } }
                })
              );
            })
            .catch(function () {});
        });
    }

    function handleMinus() {
      if (bundleQty <= 0 || isCartBusy) return;
      isCartBusy = true;

      var keysToRemove = bundleItemKeys.pop();
      if (!keysToRemove || !keysToRemove.length) {
        bundleQty = Math.max(0, bundleQty - 1);
        isCartBusy = false;
        refreshQtyUI();
        return;
      }

      var updates = {};
      for (var i = 0; i < keysToRemove.length; i++) updates[keysToRemove[i]] = 0;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function (cart) {
          bundleQty = Math.max(0, bundleQty - 1);
          isCartBusy = false;
          refreshQtyUI();
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { source: 'superbundle-qty', itemCount: cart.item_count } }
            })
          );
        })
        .catch(function (err) {
          console.error('Superbundle remove error:', err);
          bundleItemKeys.push(keysToRemove);
          isCartBusy = false;
        });
    }

    function refreshQtyUI() {
      /* Quick Buy: keep Add to Bag only — never morph into the qty stepper. */
      if (isQuickBuy) {
        if (qtySection) qtySection.style.display = 'none';
        if (atcSection) atcSection.style.display = '';
        if (bundleAtcBtn) {
          bundleAtcBtn.classList.remove('loading');
          syncQuickBuyBundleButton();
        }
        return;
      }

      if (atcSection && qtySection) {
        if (bundleQty > 0) {
          atcSection.style.display = 'none';
          qtySection.style.display = '';
          qtyInput.value = bundleQty;
          deleteIcon.hidden = bundleQty > 1;
          minusIcon.hidden = bundleQty <= 1;
        } else {
          qtySection.style.display = 'none';
          atcSection.style.display = '';
          if (bundleAtcBtn) {
            bundleAtcBtn.classList.remove('loading');
            bundleAtcBtn.disabled = false;
          }
        }
      }
      ['desktop', 'mobile'].forEach(function (k) {
        var ui = stickyBundleUI[k];
        if (!ui) return;
        if (bundleQty > 0) {
          ui.atcSection.style.display = 'none';
          ui.qtySection.style.display = '';
          ui.qtyInput.value = bundleQty;
          ui.deleteIcon.hidden = bundleQty > 1;
          ui.minusIcon.hidden = bundleQty <= 1;
        } else {
          ui.qtySection.style.display = 'none';
          ui.atcSection.style.display = '';
          if (ui.atcBtn) {
            ui.atcBtn.disabled = false;
          }
        }
      });
    }

    function setModalProductPriceHidden(hide) {
      if (!isQuickBuy) return;
      root.querySelectorAll('product-price').forEach(function (el) {
        el.style.display = hide ? 'none' : '';
      });
    }

    function fillQvPriceRow(row, data) {
      var mainEl = row.querySelector('.superbundle-qv-price__sale');
      var compareEl = row.querySelector('.superbundle-qv-price__compare');
      var discountEl = row.querySelector('.superbundle-qv-price__discount');
      var stockEl = row.querySelector('.superbundle-qv-price__stock');
      if (mainEl) mainEl.textContent = formatPrice(data.price);
      var hasCompare = data.compare && data.compare > data.price;
      var pct = hasCompare ? Math.round(((data.compare - data.price) * 100) / data.compare) : 0;
      var priceRow = row.querySelector('.superbundle-qv-price__row') || (mainEl && mainEl.parentElement);
      var label = priceRow ? priceRow.querySelector('.superbundle-qv-price__mrp') : null;
      if (!label && priceRow) {
        label = document.createElement('span');
        label.className = 'superbundle-qv-price__mrp';
        label.textContent = 'M.R.P';
        priceRow.appendChild(label);
      }
      if (label && mainEl) {
        if (hasCompare && compareEl) mainEl.after(label);
        else mainEl.before(label);
        label.style.display = '';
      }
      if (compareEl) {
        compareEl.textContent = hasCompare ? formatPrice(data.compare) : '';
        compareEl.style.display = hasCompare ? '' : 'none';
      }
      if (discountEl) {
        discountEl.textContent = hasCompare ? '(' + pct + '% OFF)' : '';
        discountEl.style.display = hasCompare ? '' : 'none';
      }
      if (stockEl) {
        if (selector.dataset.bundlePreorder === 'yes') {
          stockEl.textContent = 'Pre-order';
          stockEl.className = 'superbundle-qv-price__stock superbundle-qv-price__stock--in';
        } else {
          var inStock = selector.dataset.bundleAvailable !== 'false';
          stockEl.textContent = inStock ? 'In Stock' : 'Out of Stock';
          stockEl.className = 'superbundle-qv-price__stock superbundle-qv-price__stock--' + (inStock ? 'in' : 'out');
        }
      }
      syncQvPriceInfo(row, data);
      syncQvItemsInfo(row);
      bindQvPriceInfo(row);
    }

    function ensureQvPriceRow() {
      if (!isQuickBuy) return;
      var row = root.querySelector('.superbundle-qv-price');
      if (!row) {
        row = document.createElement('div');
        row.className = 'superbundle-qv-price';
        row.innerHTML =
          '<div class="superbundle-qv-price__row">' +
            '<span class="superbundle-qv-price__sale"></span>' +
            '<span class="superbundle-qv-price__compare"></span>' +
            '<span class="superbundle-qv-price__discount"></span>' +
          '</div>' +
          '<div class="superbundle-qv-price__stock"></div>';
      }
      row.style.setProperty('display', 'flex', 'important');

      // Keep price directly under the title (not inside the ATC wrapper at the bottom).
      var header = root.querySelector('.product-header');
      var titleBlock = root.querySelector('.view-product-title');
      if (header) {
        var titleLink = header.querySelector('a');
        if (row.parentElement !== header || (titleLink && row.previousElementSibling !== titleLink)) {
          if (titleLink && titleLink.nextSibling) {
            header.insertBefore(row, titleLink.nextSibling);
          } else {
            header.appendChild(row);
          }
        }
      } else if (titleBlock && titleBlock.parentNode) {
        if (row.previousElementSibling !== titleBlock) {
          titleBlock.parentNode.insertBefore(row, titleBlock.nextSibling);
        }
      } else if (bundleWrap && row.parentElement !== bundleWrap) {
        bundleWrap.insertBefore(row, bundleWrap.firstChild);
      }

      fillQvPriceRow(row, prices.bundle);
    }

    function hideQvPriceRow() {
      if (!isQuickBuy) return;
      var row = root.querySelector('.superbundle-qv-price');
      if (row) row.style.setProperty('display', 'none', 'important');
    }

    var priceInfoSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">' +
        '<circle cx="7" cy="7" r="6.25" stroke="currentColor" stroke-width="1.5"/>' +
        '<path d="M7 6.25V9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '<circle cx="7" cy="4.5" r="0.75" fill="currentColor"/>' +
      '</svg>';

    function priceInfoMarkup(tooltipId) {
      return (
        '<span class="price-info-wrap-pdp">' +
          '<button type="button" class="price-info-btn-pdp" aria-label="Price details" aria-expanded="false" aria-controls="' + tooltipId + '" data-price-info-trigger>' +
            priceInfoSvg +
          '</button>' +
          '<div id="' + tooltipId + '" class="price-details-tooltip-pdp" role="tooltip">' +
            '<p class="price-details-title-pdp">Price Details</p>' +
            '<div class="price-details-row-pdp">' +
              '<div>' +
                '<span class="price-details-label-pdp">Maximum Retail Price</span>' +
                '<span class="price-details-subtext-pdp">(Incl. of all taxes)</span>' +
              '</div>' +
              '<span class="price-details-value-pdp" data-price-detail="mrp"></span>' +
            '</div>' +
            '<hr class="price-details-divider-pdp">' +
            '<div class="price-details-row-pdp price-details-row-pdp--discount">' +
              '<span class="price-details-label-pdp">Discount</span>' +
              '<span class="price-details-value-pdp price-details-value-pdp--discount" data-price-detail="discount"></span>' +
            '</div>' +
            '<div class="price-details-row-pdp price-details-row-pdp--selling">' +
              '<div>' +
                '<span class="price-details-label-pdp price-details-label-pdp--bold">Selling Price</span>' +
                '<span class="price-details-subtext-pdp">(Incl. of all taxes)</span>' +
              '</div>' +
              '<span class="price-details-value-pdp price-details-value-pdp--bold" data-price-detail="selling"></span>' +
            '</div>' +
          '</div>' +
        '</span>'
      );
    }

    function setPriceInfoMode(wrap, hasCompare, sellingText, mrpText, pct) {
      if (!wrap) return;
      var tooltip = wrap.querySelector('.price-details-tooltip-pdp');
      if (tooltip) tooltip.classList.toggle('price-details-tooltip-pdp--mrp-only', !hasCompare);
      fillPriceInfo(wrap, sellingText, hasCompare ? mrpText : sellingText, pct);
    }

    function fillPriceInfo(wrap, sellingText, mrpText, pct) {
      if (!wrap) return;
      var mrp = wrap.querySelector('[data-price-detail="mrp"]');
      var discount = wrap.querySelector('[data-price-detail="discount"]');
      var selling = wrap.querySelector('[data-price-detail="selling"]');
      if (mrp) mrp.textContent = mrpText;
      if (discount) discount.textContent = pct + '% OFF';
      if (selling) selling.textContent = sellingText;
    }

    function createPriceInfo(tooltipId) {
      var holder = document.createElement('div');
      holder.innerHTML = priceInfoMarkup(tooltipId);
      return holder.firstElementChild;
    }

    function escapeHtml(value) {
      if (value == null) return '';
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function formatRupees(amount) {
      var num = Math.round(Number(amount) || 0);
      return '\u20B9 ' + num.toLocaleString('en-IN');
    }

    function parseFlyPairs(raw) {
      if (raw == null || raw === '') return [];
      var data = raw;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { return []; }
      }
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { return []; }
      }
      if (!data || typeof data !== 'object' || Array.isArray(data)) return [];
      var pairs = [];
      Object.keys(data).forEach(function (productId) {
        var variants = data[productId];
        var variantId = Array.isArray(variants) ? variants[0] : variants;
        if (variantId == null || variantId === '') return;
        pairs.push({ productId: String(productId), variantId: String(variantId) });
      });
      return pairs;
    }

    var itemsInfoSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">' +
        '<circle cx="7" cy="7" r="7" fill="currentColor"/>' +
        '<path d="M7 6.25V9.75" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>' +
        '<circle cx="7" cy="4.5" r="0.75" fill="#fff"/>' +
      '</svg>';

    function syncQvPriceInfo(row, data) {
      var priceRow = row.querySelector('.superbundle-qv-price__row');
      if (!priceRow) return;
      var hasCompare = !!(data.compare && data.compare > data.price);
      var pct = hasCompare ? Math.round(((data.compare - data.price) * 100) / data.compare) : 0;
      var sellingText = formatPrice(data.price);
      var mrpText = formatPrice(hasCompare ? data.compare : data.price);
      var infoWrap = priceRow.querySelector('.superbundle-qv-price__info');
      if (!infoWrap) {
        infoWrap = createPriceInfo('qv-price-details-' + (selector.dataset.bundleVariantId || '0'));
        infoWrap.classList.add('superbundle-qv-price__info');
      }
      var discountEl = priceRow.querySelector('.superbundle-qv-price__discount');
      if (discountEl && discountEl.parentElement === priceRow) priceRow.insertBefore(infoWrap, discountEl);
      else priceRow.appendChild(infoWrap);
      setPriceInfoMode(infoWrap, hasCompare, sellingText, mrpText, pct);
    }

    function itemsInfoMarkup(tooltipId, items) {
      if (!items || !items.length) return '';
      var rows = '';
      items.forEach(function (item) {
        var itemPrice = Number(item.price) || 0;
        var itemCompare = Number(item.compareAtPrice) || 0;
        var hasCompare = itemCompare > itemPrice;
        var itemPct = hasCompare ? Math.round(((itemCompare - itemPrice) * 100) / itemCompare) : 0;
        rows +=
          '<div class="bundle-contents__item-detail">' +
            '<p class="bundle-contents__item-detail-title">' + escapeHtml(item.title || 'Product') + '</p>' +
            '<div class="bundle-contents__item-detail-prices">' +
              (hasCompare ? '' : '<span class="bundle-contents__mrp">M.R.P</span>') +
              '<span class="bundle-contents__item-detail-sale">' + escapeHtml(formatRupees(itemPrice)) + '</span>' +
              (hasCompare
                ? '<span class="bundle-contents__mrp">M.R.P</span>' +
                  '<span class="bundle-contents__item-detail-compare">' + escapeHtml(formatRupees(itemCompare)) + '</span>' +
                  '<span class="bundle-contents__item-detail-discount">(' + itemPct + '% OFF)</span>'
                : '') +
            '</div>' +
          '</div>';
      });
      return (
        '<span class="price-info-wrap-pdp bundle-contents__price-info bundle-contents__items-info superbundle-qv-price__items">' +
          '<button type="button" class="price-info-btn-pdp" aria-label="Bundle product prices" aria-expanded="false" aria-controls="' + tooltipId + '" data-price-info-trigger>' +
            itemsInfoSvg +
          '</button>' +
          '<div id="' + tooltipId + '" class="price-details-tooltip-pdp bundle-contents__items-tooltip" role="tooltip">' +
            '<p class="price-details-title-pdp">Bundle Products</p>' +
            rows +
          '</div>' +
        '</span>'
      );
    }

    function syncQvItemsInfo(row) {
      var priceRow = row.querySelector('.superbundle-qv-price__row');
      if (!priceRow) return;
      var pairs = parseFlyPairs(selector.dataset.bundleFlyIds);
      var existing = priceRow.querySelector('.superbundle-qv-price__items');
      if (!pairs.length) {
        if (existing) existing.remove();
        delete row.dataset.qvItemsKey;
        return;
      }
      var key = pairs.map(function (pair) { return pair.variantId; }).join(',');
      if (row.dataset.qvItemsKey === key && existing) return;
      row.dataset.qvItemsKey = key;
      var token = window.PW_STOREFRONT_TOKEN || window.__PW_STOREFRONT_TOKEN__ || '';
      if (!token) return;
      var ids = pairs.map(function (pair) { return 'gid://shopify/ProductVariant/' + pair.variantId; });
      fetch('/api/2025-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({
          query: 'query QvBundleItems($ids: [ID!]!) { nodes(ids: $ids) { ... on ProductVariant { id title price { amount } compareAtPrice { amount } product { title } } } }',
          variables: { ids: ids }
        })
      })
        .then(function (response) { return response.json(); })
        .then(function (result) {
          if (!row.isConnected || row.dataset.qvItemsKey !== key) return;
          var nodes = (result && result.data && result.data.nodes) || [];
          var byId = {};
          nodes.forEach(function (node) {
            if (!node || !node.id) return;
            var id = String(node.id).replace('gid://shopify/ProductVariant/', '');
            var product = node.product || {};
            byId[id] = {
              title: product.title || node.title || '',
              price: node.price ? parseFloat(node.price.amount) : 0,
              compareAtPrice: node.compareAtPrice ? parseFloat(node.compareAtPrice.amount) : 0
            };
          });
          var items = [];
          pairs.forEach(function (pair) {
            if (byId[pair.variantId]) items.push(byId[pair.variantId]);
          });
          var current = priceRow.querySelector('.superbundle-qv-price__items');
          if (current) current.remove();
          var markup = itemsInfoMarkup('qv-bundle-items-' + (selector.dataset.bundleVariantId || '0'), items);
          if (!markup) return;
          var holder = document.createElement('div');
          holder.innerHTML = markup;
          if (holder.firstElementChild) priceRow.appendChild(holder.firstElementChild);
        })
        .catch(function () {});
    }

    function bindQvPriceInfo(row) {
      if (row.dataset.qvInfoBound === 'true') return;
      row.dataset.qvInfoBound = 'true';
      row.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-price-info-trigger]');
        var wrap = trigger ? trigger.closest('.price-info-wrap-pdp') : null;
        if (!trigger || !wrap || !row.contains(wrap)) return;
        e.preventDefault();
        e.stopPropagation();
        var isOpen = wrap.classList.contains('is-open');
        row.querySelectorAll('.price-info-wrap-pdp.is-open').forEach(function (openWrap) {
          openWrap.classList.remove('is-open');
          var openTrigger = openWrap.querySelector('[data-price-info-trigger]');
          if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          wrap.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    }

    if (!window.__qvPriceInfoDoc) {
      window.__qvPriceInfoDoc = true;
      document.addEventListener('click', function (e) {
        if (e.target.closest('.superbundle-qv-price .price-info-wrap-pdp')) return;
        document.querySelectorAll('.superbundle-qv-price .price-info-wrap-pdp.is-open').forEach(function (openWrap) {
          openWrap.classList.remove('is-open');
          var openTrigger = openWrap.querySelector('[data-price-info-trigger]');
          if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
        });
      });
    }

    function hidePriceInfo(wrap) {
      if (!wrap) return;
      wrap.style.display = 'none';
      wrap.classList.remove('is-open');
      var trigger = wrap.querySelector('[data-price-info-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function setHidden(el, hide) {
      if (!el) return;
      if (hide) {
        el.setAttribute('hidden', '');
        el.style.display = 'none';
      } else {
        el.removeAttribute('hidden');
        el.style.display = '';
      }
    }

    function ensureMrpLabel(parent, kind, beforeEl) {
      if (!parent) return null;
      var selector = kind === 'leading' ? '.mrp-label-pdp--leading' : '.mrp-label-pdp--compare';
      var label = parent.querySelector(selector);
      if (!label) {
        label = document.createElement('span');
        label.className = 'mrp-label-pdp mrp-label-pdp--' + kind;
        label.textContent = 'M.R.P';
        if (beforeEl && beforeEl.parentNode === parent) parent.insertBefore(label, beforeEl);
        else parent.appendChild(label);
      }
      return label;
    }

    function removeMrpLabel(parent, kind) {
      if (!parent) return;
      var selector = kind === 'leading' ? '.mrp-label-pdp--leading' : '.mrp-label-pdp--compare';
      var label = parent.querySelector(selector);
      if (label) label.remove();
    }

    function syncPdpPriceDetails(row, sellingText, mrpText, pct, hasCompare) {
      if (!row) return;
      var compareGroup = row.querySelector('.compare-price-pdp');
      var compareEl = row.querySelector('.compare-at-price-pdp');
      var discountEl = row.querySelector('.discount-pdp');
      var infoWrap = row.querySelector('.price-info-wrap-pdp');
      var mainGroup = row.querySelector('.price-main-pdp');
      var mainPrice = row.querySelector('.main-price-pdp');

      if (!hasCompare) {
        setHidden(compareGroup, true);
        setHidden(discountEl, true);
        ensureMrpLabel(mainGroup, 'leading', mainPrice);
        if (!infoWrap) {
          infoWrap = createPriceInfo('price-details-tooltip-sb');
          if (discountEl && discountEl.parentNode === row) row.insertBefore(infoWrap, discountEl);
          else row.appendChild(infoWrap);
        }
        setHidden(infoWrap, false);
        infoWrap.style.display = '';
        setPriceInfoMode(infoWrap, false, sellingText, mrpText, pct);
        return;
      }

      removeMrpLabel(mainGroup, 'leading');

      if (!compareGroup) {
        compareGroup = document.createElement('span');
        compareGroup.setAttribute('role', 'group');
        compareGroup.className = 'compare-price-pdp';
        compareGroup.innerHTML = '<span class="visually-hidden">Regular price&nbsp;</span><span class="mrp-label-pdp mrp-label-pdp--compare">M.R.P</span><span class="compare-at-price-pdp"></span>';
        var main = row.querySelector('.price-main-pdp');
        if (main && main.nextSibling) row.insertBefore(compareGroup, main.nextSibling);
        else row.appendChild(compareGroup);
        compareEl = compareGroup.querySelector('.compare-at-price-pdp');
      }
      setHidden(compareGroup, false);
      if (!compareEl) {
        compareEl = document.createElement('span');
        compareEl.className = 'compare-at-price-pdp';
        compareGroup.appendChild(compareEl);
      }
      ensureMrpLabel(compareGroup, 'compare', compareEl);
      compareEl.textContent = mrpText;

      if (!infoWrap) {
        infoWrap = createPriceInfo('price-details-tooltip-sb');
        if (discountEl && discountEl.parentNode === row) row.insertBefore(infoWrap, discountEl);
        else row.appendChild(infoWrap);
      }
      setHidden(infoWrap, false);
      setPriceInfoMode(infoWrap, true, sellingText, mrpText, pct);

      if (!discountEl) {
        discountEl = document.createElement('span');
        discountEl.className = 'discount-pdp';
        row.appendChild(discountEl);
      }
      discountEl.textContent = '(' + pct + '% OFF)';
      setHidden(discountEl, false);
    }

    function syncStickyMobilePriceInfo(sellingText, mrpText, pct, hasCompare) {
      if (!stickyBar) return;
      var info = stickyBar.querySelector('.product-sticky-bar__mobile-price-info');
      if (!info) return;

      var priceEl = info.querySelector('.product-sticky-bar__mobile-price');
      if (priceEl) priceEl.textContent = sellingText;

      var compareEl = info.querySelector('.product-sticky-bar__mobile-compare-price');
      var discountEl = info.querySelector('.product-sticky-bar__mobile-discount');
      var infoWrap = info.querySelector('.price-info-wrap-pdp');

      if (!hasCompare) {
        if (compareEl) compareEl.style.display = 'none';
        removeMrpLabel(info, 'compare');
        ensureMrpLabel(info, 'leading', priceEl);
        if (discountEl) discountEl.style.display = 'none';
        if (!infoWrap) {
          infoWrap = createPriceInfo('sticky-price-details-tooltip-sb');
          if (discountEl && discountEl.parentNode === info) info.insertBefore(infoWrap, discountEl);
          else info.appendChild(infoWrap);
        }
        infoWrap.style.display = '';
        setPriceInfoMode(infoWrap, false, sellingText, mrpText, pct);
        return;
      }

      if (!compareEl) {
        compareEl = document.createElement('span');
        compareEl.className = 'product-sticky-bar__mobile-compare-price';
        if (priceEl && priceEl.nextSibling) info.insertBefore(compareEl, priceEl.nextSibling);
        else info.appendChild(compareEl);
      }
      removeMrpLabel(info, 'leading');
      compareEl.textContent = mrpText;
      compareEl.style.display = '';
      ensureMrpLabel(info, 'compare', compareEl);

      if (!infoWrap) {
        infoWrap = createPriceInfo('sticky-price-details-tooltip-sb');
        if (discountEl && discountEl.parentNode === info) info.insertBefore(infoWrap, discountEl);
        else info.appendChild(infoWrap);
      }
      infoWrap.style.display = '';
      setPriceInfoMode(infoWrap, true, sellingText, mrpText, pct);

      if (!discountEl) {
        discountEl = document.createElement('span');
        discountEl.className = 'product-sticky-bar__mobile-discount';
        info.appendChild(discountEl);
      }
      discountEl.textContent = '(' + pct + '% OFF)';
      discountEl.style.display = '';
    }

    function findPdpPriceRow() {
      var scoped = root.querySelector && root.querySelector('product-price .price-row-pdp');
      if (scoped) return scoped;
      return document.querySelector('.product-information product-price .price-row-pdp, [data-product-grid-content] product-price .price-row-pdp');
    }

    function updatePrice(data) {
      var sellingText = formatPrice(data.price);
      var hasCompare = !!(data.compare && data.compare > data.price);
      var pct = hasCompare ? Math.round(((data.compare - data.price) * 100) / data.compare) : 0;
      var mrpText = hasCompare ? formatPrice(data.compare) : '';

      var priceRow = findPdpPriceRow();
      var mainEl = priceRow ? priceRow.querySelector('.main-price-pdp') : (root.querySelector && root.querySelector('.main-price-pdp'));
      if (mainEl) mainEl.textContent = sellingText;
      syncPdpPriceDetails(priceRow, sellingText, mrpText, pct, hasCompare);

      if (isQuickBuy && window.PWPdpPromo && typeof window.PWPdpPromo.applyWithin === 'function') {
        var promoRaw = root.getAttribute && root.id === 'quick-add-modal-content'
          ? root.getAttribute('data-pw-promo')
          : (root.querySelector('#quick-add-modal-content') || root).getAttribute('data-pw-promo');
        if (!promoRaw && root.getAttribute) promoRaw = root.getAttribute('data-pw-promo');
        if (promoRaw) {
          try {
            window.PWPdpPromo.applyWithin(root, JSON.parse(promoRaw));
          } catch (e) {}
        }
      }

      if (!stickyBar) return;

      var desktopPrice = stickyBar.querySelector('.product-sticky-bar__price');
      var desktopCompare = stickyBar.querySelector('.product-sticky-bar__compare-price');
      var desktopDiscount = stickyBar.querySelector('.product-sticky-bar__discount');
      if (desktopPrice) desktopPrice.textContent = sellingText;
      var desktopPricing = desktopPrice ? desktopPrice.parentElement : null;
      if (hasCompare) {
        removeMrpLabel(desktopPricing, 'leading');
        if (desktopCompare) {
          desktopCompare.textContent = mrpText;
          desktopCompare.style.display = '';
          ensureMrpLabel(desktopPricing, 'compare', desktopCompare);
        }
        if (desktopDiscount) {
          desktopDiscount.textContent = '(' + pct + '% OFF)';
          desktopDiscount.style.display = '';
        }
      } else {
        removeMrpLabel(desktopPricing, 'compare');
        ensureMrpLabel(desktopPricing, 'leading', desktopPrice);
        if (desktopCompare) desktopCompare.style.display = 'none';
        if (desktopDiscount) desktopDiscount.style.display = 'none';
      }

      syncStickyMobilePriceInfo(sellingText, mrpText, pct, hasCompare);
    }

    function swapGallery(mode) {
      if (mode === 'bundle' && !isBundleGallery) {
        if (bundleGalleryNode) {
          doGallerySwap();
        } else if (galleryFetching) {
          pendingBundleSwap = true;
        } else if (bundleHandle) {
          pendingBundleSwap = true;
          galleryFetching = true;
          fetch('/products/' + bundleHandle)
            .then(function (r) {
              return r.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var bg = doc.querySelector('media-gallery');
              if (bg) bundleGalleryNode = document.adoptNode(bg);
              galleryFetching = false;
              if (pendingBundleSwap) {
                pendingBundleSwap = false;
                var ch = selector.querySelector('input[type="radio"][value="bundle"]');
                if (ch && ch.checked) doGallerySwap();
              }
            })
            .catch(function () {
              galleryFetching = false;
              pendingBundleSwap = false;
            });
        }
      } else if (mode === 'regular' && isBundleGallery) {
        pendingBundleSwap = false;
        if (originalGalleryNode) {
          var g = root.querySelector('media-gallery');
          if (g) {
            g.replaceWith(originalGalleryNode);
            isBundleGallery = false;
          }
        }
      }
    }

    function switchTo(mode) {
      if (mode === 'bundle') {
        if (buyBlock && !isFlyParent) buyBlock.style.display = 'none';
        if (!bundleWrap) bundleWrap = createBundleUI();
        bundleWrap.style.display = '';
        if (!isQuickBuy) {
          if (!stickyBundleUI.desktop && !stickyBundleUI.mobile) createStickyBundleUI();
          if (stickyDesktopForm) stickyDesktopForm.style.display = 'none';
          if (stickyMobileForm) stickyMobileForm.style.display = 'none';
          if (stickyBundleUI.desktop) stickyBundleUI.desktop.wrap.style.display = '';
          if (stickyBundleUI.mobile) stickyBundleUI.mobile.wrap.style.display = '';
        }
        refreshQtyUI();
        if (isQuickBuy) {
          setModalProductPriceHidden(true);
          ensureQvPriceRow();
        }
        if (!isFlyParent) {
          if (!isQuickBuy) updatePrice(prices.bundle);
          swapGallery('bundle');
          if (titleEl && bundleTitle) titleEl.textContent = bundleTitle;
          root.querySelectorAll('input[data-linked-main-variant-input]').forEach(function (radio) {
            radio.checked = false;
            radio.dataset.currentChecked = 'false';
          });
        }
      } else {
        if (buyBlock) buyBlock.style.display = '';
        if (bundleWrap) bundleWrap.style.display = 'none';
        if (!isQuickBuy) {
          if (stickyDesktopForm) stickyDesktopForm.style.display = '';
          if (stickyMobileForm) stickyMobileForm.style.display = '';
          if (stickyBundleUI.desktop) stickyBundleUI.desktop.wrap.style.display = 'none';
          if (stickyBundleUI.mobile) stickyBundleUI.mobile.wrap.style.display = 'none';
        }
        if (isQuickBuy) {
          hideQvPriceRow();
          setModalProductPriceHidden(false);
        }
        updatePrice(prices.regular);
        swapGallery('regular');
        if (titleEl && regularTitle) titleEl.textContent = regularTitle;
        var currentId = root.querySelector('[data-linked-main-variants]')
          ? root.querySelector('[data-linked-main-variants]').dataset.currentProductId
          : undefined;
        root.querySelectorAll('input[data-linked-main-variant-input]').forEach(function (radio) {
          var isCurrent = currentId && String(radio.dataset.productId) === String(currentId);
          radio.checked = !!isCurrent;
          radio.dataset.currentChecked = isCurrent ? 'true' : 'false';
        });
      }
    }

    selector.__sbSwitchTo = switchTo;

    function selectLabel(label, e) {
      if (e && e.cancelable) e.preventDefault();
      var radio = label.querySelector('input[type="radio"]');
      if (!radio || radio.checked) return;
      radio.checked = true;
      switchTo(radio.value);
    }

    var labels = selector.querySelectorAll('.variant-option__button-label');
    for (var i = 0; i < labels.length; i++) {
      (function (label) {
        var startX = 0;
        var startY = 0;
        label.addEventListener('pointerdown', function (e) {
          startX = e.clientX;
          startY = e.clientY;
        });
        label.addEventListener('pointerup', function (e) {
          if (Math.abs(e.clientX - startX) > 10 || Math.abs(e.clientY - startY) > 10) return;
          selectLabel(label, e);
        });
        label.addEventListener('click', function (e) {
          selectLabel(label, e);
        });
      })(labels[i]);
    }

    if (isQuickBuy && isFlyParent) {
      var variantTarget = root.closest('quick-add-dialog') || root;
      variantTarget.addEventListener('variant:update', function (event) {
        if (!selector.isConnected) return;
        var html = event.detail && event.detail.data && event.detail.data.html;
        if (!html || !html.querySelector) return;
        var next = html.querySelector('.superbundle-fly-parent');
        if (!next) return;
        ['bundlePrice', 'bundleComparePrice', 'bundleFlyIds', 'bundleOfferId', 'bundleAvailable', 'bundlePreorder', 'bundleDigitalMap', 'bundleVariantId', 'bundleName'].forEach(function (key) {
          if (next.dataset[key] != null) selector.dataset[key] = next.dataset[key];
        });
        prices.bundle = {
          price: parseInt(selector.dataset.bundlePrice, 10),
          compare: parseInt(selector.dataset.bundleComparePrice, 10)
        };
        ensureQvPriceRow();
        syncQuickBuyBundleButton();
      });
    }

    if (isFlyParent) {
      switchTo('bundle');
    }

    syncBundleStateFromCart();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.superbundle-selector').forEach(initSelector);
  }

  /**
   * Quick Buy remount: drop stale listeners/wrappers, then bind a fresh instance.
   * Never call this on the live PDP node — PDP uses initAll() once.
   */
  function initIn(root) {
    if (!root) return;
    root.querySelectorAll('.superbundle-atc-wrapper').forEach(function (el) {
      el.remove();
    });
    root.querySelectorAll('.superbundle-selector').forEach(function (selector) {
      var clone = selector.cloneNode(true);
      clone.removeAttribute('data-sb-inited');
      selector.replaceWith(clone);
      initSelector(clone);
    });
  }

  window.PWSuperbundle = {
    initSelector: initSelector,
    initAll: initAll,
    initIn: initIn
  };

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
